export default function MondialRelayShippingSync($) {
  let lastValue      = null;
  let sessionObserver = null;
  let stripeObserver  = null;

  // ---------------------------------------------------------------------------
  // Express Checkout overlay (Apple Pay / Google Pay)
  //
  // State is driven by window.gtMRState injected by PHP (GT_MondialRelay_Hooks):
  //   - on initial page load via wp_footer
  //   - on every checkout AJAX refresh via woocommerce_review_order_after_submit
  //
  // window.gtMRState shape: { needsParcelShop: boolean }
  //
  // Overlay is placed on each individual Stripe button div
  // (id starting with "wc-stripe-express-checkout-element-") so it covers
  // exactly the iframe surface. No text — click-blocker only.
  //
  // A MutationObserver watches the wrapper so the overlay is applied as soon
  // as Stripe mounts its iframes, regardless of timing.
  // ---------------------------------------------------------------------------

  const OVERLAY_CLASS   = 'gt-ece-overlay';
  const WRAPPER_ID      = 'wc-stripe-express-checkout-element';
  const BUTTON_SELECTOR = '[id^="wc-stripe-express-checkout-element-"]';

  function applyOverlay() {
    const wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return;

    const state       = window.gtMRState ?? { needsParcelShop: false };
    const shouldBlock = state.needsParcelShop === true;
    const buttons     = wrapper.querySelectorAll(BUTTON_SELECTOR);

    buttons.forEach((btn) => {
      let overlay = btn.querySelector('.' + OVERLAY_CLASS);

      if (shouldBlock) {
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = OVERLAY_CLASS;
          Object.assign(overlay.style, {
            position: 'absolute',
            inset:    '0',
            zIndex:   '10000',
            cursor:   'not-allowed',
          });
          btn.style.position = 'relative';
          btn.appendChild(overlay);
        }
      } else {
        if (overlay) {
          overlay.remove();
          btn.style.position = '';
        }
      }
    });
  }

  /**
   * Watch the Stripe wrapper with a MutationObserver so the overlay is applied
   * as soon as Stripe inserts its button iframes — no setTimeout guessing.
   * Disconnects once buttons are found to avoid unnecessary observation.
   */
  function watchStripeWrapper() {
    const wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return;

    // Apply immediately in case buttons are already present (e.g. after AJAX refresh)
    applyOverlay();

    if (stripeObserver) stripeObserver.disconnect();

    stripeObserver = new MutationObserver(() => {
      const buttons = wrapper.querySelectorAll(BUTTON_SELECTOR);
      if (buttons.length > 0) {
        applyOverlay();
      }
    });

    stripeObserver.observe(wrapper, { childList: true, subtree: true });
  }

  // ---------------------------------------------------------------------------
  // Mondial Relay session sync
  // ---------------------------------------------------------------------------

  function sendToSession() {
    const mr = window.gt_configuration?.gilbertMR;
    if (!mr) return;

    const parcelShopId   = $('#mrwp_parcel_shop_id').val() ?? '';
    const el             = document.getElementById('parcel_shop_info');
    const parcelShopText = el
      ? el.innerHTML.replace(/<br\s*\/?>/gi, '|').replace(/<[^>]+>/g, '').trim()
      : '';

    if (parcelShopText === lastValue) return;
    lastValue = parcelShopText;

    $.post(mr.updateUrl, {
      nonce:            mr.nonce,
      parcel_shop_text: parcelShopText,
      parcel_shop_id:   parcelShopId,
    })
    .done(() => {
      // Parcel shop selected (non-empty) or cleared (empty) — update overlay
      // immediately without waiting for the next checkout AJAX refresh.
      if (window.gtMRState) {
        window.gtMRState.needsParcelShop = parcelShopText.length === 0;
      }
      applyOverlay();
    })
    .fail((xhr) => console.error('[MR] POST error:', xhr.statusText));
  }

  function attachSessionObserver() {
    const el = document.getElementById('parcel_shop_info');
    if (!el) return;

    if (sessionObserver) sessionObserver.disconnect();

    sessionObserver = new MutationObserver(sendToSession);
    sessionObserver.observe(el, { childList: true, subtree: true, characterData: true });
  }

  // Listen for the custom event dispatched by the PHP-injected inline script
  // (fired on every checkout AJAX refresh after the fragment is in the DOM)
  document.addEventListener('gt:mr:state', () => {
    watchStripeWrapper();
  });

  // After each checkout AJAX refresh
  $(document).on('updated_checkout', () => {
    attachSessionObserver();
    watchStripeWrapper();
  });

  // Initial setup
  attachSessionObserver();
  watchStripeWrapper();
}
